@let options = options$ | async;
<nz-select
  class="w-100"
  [nzDropdownStyle]="nzDropdownStyle"
  [nzShowArrow]="true"
  [nzShowSearch]="true"
  (ngModelChange)="saveSelected($event)"
  [ngModel]="selected$ | async"
  [nzPlaceHolder]="'general.staff_filter' | translate"
  [nzCustomTemplate]="selectedTemplate"
  [nzDisabled]="!hasUserReadPermissions"
  nz-tooltip
  [nzTooltipTitle]="
    !hasUserReadPermissions ? ('general.forbidden_action' | translate) : ''
  "
>
  @for (option of options; track option) {
    <nz-option [nzLabel]="option.name" [nzValue]="option.id" nzCustomContent>
      <div class="d-flex justify-content-between w-100">
        <span class="text-truncate">{{ option.name }}</span>
        <span
          nz-tooltip
          [nzTooltipTitle]="
            (option.status
              ? 'page.working_times.monthly_view.monthly_closure_status.' +
                option.status
              : 'page.working_times.monthly_view.monthly_closure_status.open'
            ) | translate
          "
          [class]="'status--' + option.status"
        >
          {{
            (option.status
              ? 'page.payroll.monthly_closure.status.' + option.status
              : 'page.payroll.monthly_closure.status.open'
            ) | translate
          }}
        </span>
      </div>
    </nz-option>
  }
</nz-select>

<ng-template #selectedTemplate let-selected>
  @let user = selected | selectedFilter: options;
  <div class="d-flex justify-content-between w-100">
    <span class="text-truncate">{{ user?.name }}</span>
    <span
      nz-tooltip
      [nzTooltipTitle]="
        (user?.status
          ? 'page.working_times.monthly_view.monthly_closure_status.' +
            $safeNavigationMigration(user?.status)
          : 'page.working_times.monthly_view.monthly_closure_status.open'
        ) | translate
      "
      [class]="'status--' + user?.status"
    >
      {{
        (user?.status
          ? 'page.payroll.monthly_closure.status.' +
            $safeNavigationMigration(user?.status)
          : 'page.payroll.monthly_closure.status.open'
        ) | translate
      }}
    </span>
  </div>
</ng-template>

@if (showLabel) {
  <wilson-filter-label [label]="'general.staff_filter' | translate">
  </wilson-filter-label>
}
